import './Story.css'
import { FC } from 'react'
import { Flex } from 'antd'
import { story } from '../../contents/story'
import { useResponxiveContext } from '../../context/responsive-context'

export const Story: FC = () => {
  const { useVertical } = useResponxiveContext()
  return (
    <Flex className="Story-container">
    <Flex className="Story-main-container">
    <Flex className="Story-main-text-container" vertical justify={'space-evenly'} >
        <div className={useVertical ? "Story-main-title-vertical" : "Story-main-title"}>
        {story.main.title}
        </div>
    {story.main.paragraphs.map(p => {
      return (
        <div className={useVertical ? "Story-main-text-vertical" : "Story-main-text"}>
          {p}
        </div>
      )
    })}
    </Flex>
    </Flex>
    </Flex>
  )
}
